import { TextsLanguages } from '@types'

export const useTexts = (lang: TextsLanguages = 'pt-br') => {
  const texts = {
    'pt-br': {
      close: 'Agora não',
      title: 'Receber notificação do Tino?',
      description:
        'Receba seus boletos, notificações de novos produtos e promoções.',
      submit: 'Sim',
    },
  }

  return texts[lang]
}
